import { useDispatch, useSelector } from "react-redux"
import { setAdminCommunityId } from "../store/Reducers/activeCommunity"
import { useCallback, useMemo } from "react"
import { can as canIn } from "../utils/permissions"


export default function useActiveAdminCommunity() {
  const activeCommunities = useSelector(state => state.activeCommunity)
  const activeCommunityId = activeCommunities.admin
  const { staff } = useSelector(state => state.status)
  const activeCommunity = useMemo(() => staff?.find(e => e.uuid == activeCommunityId), [staff, activeCommunityId])

  const dispatch = useDispatch()

  const setActiveCommunityId = (communityId) => {
    dispatch(setAdminCommunityId(communityId))
  }

  // ¿Tiene alguno de estos permisos en la comunidad activa?
  const can = useCallback((...permissions: string[]) => canIn(activeCommunity, ...permissions), [activeCommunity])

  return {
    community: activeCommunity,
    communityId: activeCommunityId,
    setActiveCommunityId,
    can,
  }
}
